<template>
  <path
    d="M31 22.247H22V17.9838C22 16.6384 23.1815 15.4413 24.7745 15.4413H28.2255C29.8185 15.4413 31 16.6384 31 17.9838V22.247ZM27.8725 12.6316H25.1275V12.5182C25.1275 12.2908 25.3433 12 25.7451 12H27.2549C27.6567 12 27.8725 12.2908 27.8725 12.5182V12.6316ZM22 31.0283H31V33.4696C31 34.256 30.3013 35 29.3039 35H23.6961C22.6987 35 22 34.256 22 33.4696V31.0283ZM22 25.0567H31V28.2186H22V25.0567Z"
    fill="#FCFCFC"
    stroke="#FCFCFC"
    stroke-width="2"
  />
</template>
